export default __webpack_public_path__ + "static/after1-160c89250d3139dec2df26b7e7a4e26e.jpg";